module.exports = __webpack_public_path__ + "img/adv1.3cba0f12.svg";